import React from 'react'
import style from './Equipmentstone.module.css'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'

const EquipmentStone = () => {
  const { t } = useTranslation()
  return (
    <div className={style.engineering} id={'sklo'}>
      <div className={`${'customContainer'} ${style.engineering_wrap}`}>
        <h2 className={style.title}>{t('equipmentStone.title')}</h2>
        <p className={style.desc}>{t('equipmentStone.desc')}</p>
        <Link to={'/engineering/glass-stone'} className={style.button}>
          {t('equipmentThermoplastics.button')}
        </Link>
        <div className={style.block_arrow}>
          <ScrollArrow />
        </div>
      </div>
    </div>
  )
}

export default EquipmentStone
